import { useState, useRef, useCallback, useEffect } from 'react'; // Aggiunto useEffect
import { useShallow } from 'zustand/react/shallow'; // Decommentato e necessario
import useGeoData from '../../../store/useGeoData'; // Decommentato e necessario
// Rimosso import type { GeoDataState } non strettamente necessario qui

/**
 * Custom hook per gestire lo stato UI della left-panel.
 * Isola la logica di stato relativa alla visualizzazione (menu aperti,
 * dialog) dal componente principale.
 */
export const useLeftPanelState = () => {
  // --- Rimosso stato globale UI (isleft-panelCollapsed, toggleleft-panel) ---

  // --- Stati UI Locali ---
  const [activeMenuId, setActiveMenuId] = useState<string | null>(null); // ID del menu attivo (null se nessuno)
  const [isSaveProjectDialogOpen, setIsSaveProjectDialogOpen] = useState(false);

  // --- Ref ---
  // Ref per il contenitore principale della left-panel
  const LeftPanelContainerRef = useRef<HTMLDivElement>(null);

  // --- Sottoscrizione allo stato globale ---
  // Ottiene il numero di layer dallo store, usando useShallow per ottimizzare
  const layerCount = useGeoData(useShallow(state => state.dataLayers.length));
  
  // --- Ref per logica interna ---
  // Ref per memorizzare il conteggio precedente dei layer
  const prevLayerCountRef = useRef(layerCount);

  // --- Callbacks ---

  /**
   * Gestisce il toggle dei menu principali con logica accordion.
   * Apre il menu cliccato e chiude gli altri, o chiude il menu cliccato se già aperto.
   * @param menuId L'ID univoco del menu da aprire/chiudere.
   */
  const handleMenuToggle = useCallback((menuId: string) => {
    setActiveMenuId(prevActiveMenuId =>
      prevActiveMenuId === menuId ? null : menuId
    );
  }, []); // Nessuna dipendenza, setActiveMenuId è stabile

  // --- Effetti ---

  /**
   * Effetto per espandere automaticamente il menu 'Layers' quando viene aggiunto un nuovo layer.
   */
  useEffect(() => {
    // Controlla se il numero di layer è aumentato rispetto al render precedente
    if (layerCount > prevLayerCountRef.current) {
      // Se sì, imposta il menu 'layers' come attivo
      setActiveMenuId('layers'); // Assumendo che 'layers' sia l'ID corretto
    }
    // Aggiorna il ref con il conteggio attuale per il prossimo render
    prevLayerCountRef.current = layerCount;
  }, [layerCount, setActiveMenuId]); // Dipendenze: layerCount e setActiveMenuId

  // Rimossa logica per calcolare panelTop (calculatePanelTop)
  // Rimossa logica per gestire click modifica stile (handleEditStyleClick)
  // Rimossa logica per chiudere editor stile (handleCloseStyleEditor)
  // Rimosso handleSubmenuClick non più necessario

  // --- Valori Restituiti ---
  return {
    // Stati
    activeMenuId,
    isSaveProjectDialogOpen,

    // Funzioni Setter
    // setActiveMenuId non viene esposto direttamente, si usa handleMenuToggle
    setIsSaveProjectDialogOpen,

    // Ref
    LeftPanelContainerRef,

    // Handlers Logici
    handleMenuToggle,
    // Rimosso: handleEditStyleClick,
    // Rimosso: handleCloseStyleEditor,
  };
};